export const FETCH_COACHDASHBOARD_REQUEST = 'FETCH_COACHDASHBOARD_REQUEST';
export const FETCH_COACHDASHBOARD_SUCCESS = 'FETCH_COACHDASHBOARD_SUCCESS';
export const FETCH_COACHDASHBOARD_FAILURE = 'FETCH_COACHDASHBOARD_FAILURE';
